import React from "react";
import Jumbotron from "../../../components/Jumbotron.component";
import TableProjectSPV from "../../../components/TableProjectSPV.component";
import SEO from "../../SEO";

const PendingProject = () => {
  return (
    <>
      <SEO title="Supervisor" description="Project From Planner" content="Project From Planner"  />

     <Jumbotron
        notPlanner={true}
        description={
          "This menu is representative all projects that are came from planner. You may approve, return and reject projects that are submitted by planner"
        }
      />
      <TableProjectSPV />
    </>
  );
};

export default PendingProject;
